import React from "react";

const Developer = () => {
  return (
    <section className="py-10 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        {/* Heading */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-[#090C6A]">
            About Siddhi Group
          </h2>
          <div className="w-24 h-1 bg-[#090C6A] mx-auto mt-3 rounded"></div>
        </div>

        <p className="text-gray-700 leading-relaxed text-justify">
          Siddhi Group is one of the countries leading Real Estate Developers
          spread across Navi Mumbai, MMR region and Pune. The group has
          undertaken various development schemes from CIDCO in adjoining areas
          of Navi Mumbai adding to its portfolio high value projects. Within a
          short span of 10 years, the group has successfully completed more than
          30 lakh Sq ft of construction work in residential, commercial and
          shopping malls and plans to increase the tally every year. Our
          buildings mark a perfection of aesthetic design & quality
          construction. We strive to bring a unique combination of knowledge,
          innovation and experience in every aspect of project expertise. The
          customer satisfaction had to be institutionalized across the spectrum
          with the ultimate aim to provide the customers with ultimate class,
          quality and design.
        </p>
      </div>
    </section>
  );
};

export default Developer;
